import { Button } from '@themesberg/react-bootstrap';
import React from 'react'
import { getLotoTypeLabelWithFilter } from '../../../../helper/lotoType'

const formatDateTime = (dateStr) => {
  if (!dateStr) return ''
  const d = new Date(dateStr)
  const pad = (n) => String(n).padStart(2, '0')
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export const TableRow = (props) => {
  const { ticket, user, netValue, tax, fee, grossValue, isPaid, id, createdAt } = props.data;

  return (
    <tr>
      <td className="text-center">
        <Button onClick={() => props.onShowDetailPress(props.data)}>
          Xem giải thưởng
        </Button>
        {!isPaid &&
          <>
            &nbsp;
            &nbsp;
            &nbsp;
            <Button className='btn-danger' onClick={() => props.onPaidPress(id, user.phone, ticket.id)}>
              Trả thưởng
            </Button>
          </>
        }
      </td>
      <td>
      <b>{(user && user.endPointId) || ""}</b><br />
        {(user && user.name) || ""}<br />
        <span><strong className={`text-primary`}>{(user && user.phone) || ""}</strong></span>
      </td>
      <td className='text-center'>
        {ticket.Channel.name}<br />
        {ticket.resultDate}
      </td>
      <td className="text-center">
        {getLotoTypeLabelWithFilter(ticket.LotoType, ticket.baoFilter, ticket.baoDigits)}<br />
        {ticket.numbers}<br />
        {new Intl.NumberFormat('vn-VI', {}).format(ticket.value)}
        </td>
      <td className="text-center">{new Intl.NumberFormat('vn-VI', {}).format(grossValue)}</td>
      <td className="text-center text-danger">{new Intl.NumberFormat('vn-VI', {}).format(tax)}</td>
      <td className="text-center text-warning">{new Intl.NumberFormat('vn-VI', {}).format(fee)}</td>
      <td className="text-center text-success">{new Intl.NumberFormat('vn-VI', {}).format(netValue)}</td>
      <td className="text-center">{formatDateTime(createdAt)}</td>
    </tr>
  );
};
